import { ChangeEvent } from 'react';
import cn from 'classnames';
import SearchInput from '@/Framework/UI/Molecules/Form/SearchInput';
import {
  useArticlesTileContext,
} from '@/finsight/application/CreditFlowResearch/Articles/ArticlesTile/ArticlesTileContext';
import IconDescription from '@dealroadshow/uikit/core/components/Icon/IconDescription';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import { Link } from '@/Framework/Router/Next/Link';
import {
  mapArticleTypeToTitle,
  SEARCH_MAX_LENGTH,
  SEARCH_MIN_LENGTH,
} from '@/finsight/ui/components/creditFlow/articles/constants';
import { useGetLinkToAllArticles } from '@/finsight/ui/components/creditFlow/articles/common/useGetLinkToAllArticles';
import TileSubscribeButton from 'src/finsight/ui/components/creditFlow/articles/ArticlesTiles/TileSubscribeButton';

import styles from './articlesTile.scss';
import spacesStyles from '@dealroadshow/uikit/core/styles/helpers/spaces.scss';
import alignStyles from '@dealroadshow/uikit/core/styles/helpers/align.scss';

const TileHeader = () => {
  const {
    setSearch,
    search,
    themeType,
    articlesData: { debouncedSearch },
    isSubscribeButtonVisible,
  } = useArticlesTileContext();

  const onSearchChange = ({ target: { value } }: ChangeEvent<HTMLInputElement>) => {
    setSearch(value);
    if (value.length >= SEARCH_MIN_LENGTH || !value.length) {
      if (value.length > SEARCH_MAX_LENGTH) {
        debouncedSearch(value.slice(0, SEARCH_MAX_LENGTH));
      } else {
        debouncedSearch(value);
      }
    }
  };

  const {
    link,
    tooltip,
  } = useGetLinkToAllArticles(themeType);

  return (
    <div className={ styles.headerContent }>
      <h3 className={ cn(spacesStyles.mn, styles.title) }>{ mapArticleTypeToTitle[themeType] }</h3>
      <div className={ alignStyles.flexCenter }>
        { isSubscribeButtonVisible && <TileSubscribeButton themeType={ themeType } /> }
        <Tooltip content={ tooltip } containerClassName={ cn(alignStyles.flexCenter, styles.linkToPage) }>
          <Link
            to={ link }
          >
            <IconDescription
              data-test="articlesTileFilterButton"
              className={ styles.icon }
            />
          </Link>
        </Tooltip>
      </div>
      <div className={ styles.search }>
        <SearchInput
          onChange={ onSearchChange }
          value={ search }
          placeholder="Filter by Headline or Description"
          formFieldClassName={ styles.searchInputField }
        />
      </div>
    </div>
  );
};

export default TileHeader;
